module.exports = __webpack_public_path__ + "static/media/logo_noa-01.b75405d1.svg";